import { render } from "./UnlockCourse.vue?vue&type=template&id=6b0e0ff0&scoped=true"
import script from "./UnlockCourse.vue?vue&type=script&lang=js"
export * from "./UnlockCourse.vue?vue&type=script&lang=js"

import "./UnlockCourse.vue?vue&type=style&index=0&id=6b0e0ff0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b0e0ff0"

export default script